(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('SimPhone', SimPhone);

    SimPhone.$inject = ['$resource'];

    function SimPhone ($resource) {
        var resourceUrl =  'api/sim-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
